import { Container, Header } from "@cloudscape-design/components-themed";
import { Dispatch, SetStateAction } from "react";
import {
  CompanyInfoForBankAccount,
  BankAccountsUpdateRequest,
} from "../../../features/api-interfaces";
import { IErrMsg, LABELS } from "../constants";
import { PaymentTargetCompanyReference } from "./PaymentTargetCompanyReference";
import { PaymentTargetCompanyUpdate } from "./PaymentTargetCompanyUpdate";

interface IPaymentTargetCompany {
  isFetching: boolean;
  paymentTargetCompany?: CompanyInfoForBankAccount;
  isModalOpen: boolean;
  isUpdate?: boolean;
  editingRequest?: BankAccountsUpdateRequest;
  setEditingRequest?: Dispatch<SetStateAction<BankAccountsUpdateRequest>>;
  errMsg?: IErrMsg;
  setErrMsg?: Dispatch<SetStateAction<IErrMsg>>;
}

/**
 * 入金口座情報照会・更新 入金先事業者情報
 */
export const PaymentTargetCompany = (props: IPaymentTargetCompany) => {
  const {
    isFetching,
    paymentTargetCompany,
    isModalOpen,
    isUpdate = false,
    editingRequest,
    setEditingRequest,
    errMsg,
    setErrMsg,
  } = props;

  return (
    <Container
      header={
        <Header variant={"h2"}>
          {LABELS.PAYMENT_TARGET_COMPANY_INFO_LABEL}
        </Header>
      }
    >
      {isUpdate ? (
        <PaymentTargetCompanyUpdate
          editingRequest={editingRequest}
          setEditingRequest={setEditingRequest}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
        />
      ) : (
        <PaymentTargetCompanyReference
          isFetching={isFetching}
          paymentTargetCompany={paymentTargetCompany}
          isModalOpen={isModalOpen}
        />
      )}
    </Container>
  );
};
